/**
 * Zustand store for flight input state
 */

import { create } from 'zustand';
import { parseItinerary } from '../services/airportService';
import type { FlightInput } from '../types';

interface FlightStore {
  currentFlight: Partial<FlightInput>;
  itinerary: string;
  setItinerary: (itinerary: string) => void;
  setDate: (date: string) => void;
  setAltitudeFeet: (feet?: number) => void;
  reset: () => void;
}

const initialState: Partial<FlightInput> = {
  origin: '',
  destination: '',
  date: '',
  durationMinutes: 0,
  altitudeFeet: undefined,
};

export const useFlightStore = create<FlightStore>((set) => ({
  currentFlight: initialState,
  itinerary: '',
  setItinerary: (itinerary) => {
    const parsed = parseItinerary(itinerary);
    set((s) => ({
      itinerary,
      currentFlight: parsed
        ? {
            ...s.currentFlight,
            origin: parsed.originIata,
            destination: parsed.destIata,
            durationMinutes: parsed.durationMinutes,
          }
        : {
            ...s.currentFlight,
            origin: '',
            destination: '',
            durationMinutes: 0,
          },
    }));
  },
  setDate: (date) =>
    set((s) => ({ currentFlight: { ...s.currentFlight, date } })),
  setAltitudeFeet: (altitudeFeet) =>
    set((s) => ({ currentFlight: { ...s.currentFlight, altitudeFeet } })),
  reset: () => set({ currentFlight: initialState, itinerary: '' }),
}));
